import gql from 'graphql-tag'

export const fetchPermissionsQuery = gql(`
  query {
    getPortalConfig {
      sections
    }
  }
`)
